import React from 'react';
import './App.css';
import 'antd/lib/col/style/css';
import 'antd/lib/date-picker/style/css';
import 'antd/lib/select/style/css';
import 'antd/lib/table/style/css';
import ReduxContainer from "./components/Root/ReduxContainer";

function App() {
  return (
      <ReduxContainer/>
  );
}

export default App;
